var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import SearchIcon from "@mui/icons-material/Search";
import styled from "styled-components";
import { T, FONT } from "../admin.theme";
var Wrap = styled.label(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  ", "\n  background: ", ";\n  border: 1px solid ", ";\n  border-radius: ", "px;\n  padding: 10px 14px;\n  transition: border-color 160ms;\n\n  &:focus-within {\n    border-color: ", ";\n  }\n\n  svg {\n    font-size: 18px;\n    color: ", ";\n    flex-shrink: 0;\n  }\n"], ["\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  ", "\n  background: ", ";\n  border: 1px solid ", ";\n  border-radius: ", "px;\n  padding: 10px 14px;\n  transition: border-color 160ms;\n\n  &:focus-within {\n    border-color: ", ";\n  }\n\n  svg {\n    font-size: 18px;\n    color: ", ";\n    flex-shrink: 0;\n  }\n"])), function (_a) {
    var $fill = _a.$fill;
    return ($fill ? "flex: 1 1 0; width: 100%;" : "width: 300px;");
}, T.surface, T.border, T.radiusSm, T.accentTintStrong, T.textMuted);
var Input = styled.input(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  flex: 1;\n  min-width: 0;\n  border: none;\n  outline: none;\n  background: transparent;\n  font-family: ", ";\n  font-size: 14px;\n  color: ", ";\n\n  &::placeholder {\n    color: ", ";\n  }\n"], ["\n  flex: 1;\n  min-width: 0;\n  border: none;\n  outline: none;\n  background: transparent;\n  font-family: ", ";\n  font-size: 14px;\n  color: ", ";\n\n  &::placeholder {\n    color: ", ";\n  }\n"])), FONT.body, T.textPrimary, T.textMuted);
// Поле поиска макета: иконка лупы + input на surface.
export var SearchBox = function (_a) {
    var fill = _a.fill, rest = __rest(_a, ["fill"]);
    return (_jsxs(Wrap, { "$fill": fill, children: [_jsx(SearchIcon, {}), _jsx(Input, __assign({}, rest))] }));
};
var templateObject_1, templateObject_2;
